var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.795 7.20921C19.0683 7.48816 19.0683 7.94042 18.795 8.21936L10.395 16.7908C10.1216 17.0697 9.67839 17.0697 9.40503 16.7908L5.20503 12.5051C4.93166 12.2261 4.93166 11.7739 5.20503 11.4949C5.47839 11.216 5.92161 11.216 6.19497 11.4949L9.9 15.2756L17.805 7.20921C18.0784 6.93026 18.5216 6.93026 18.795 7.20921Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRead);
export default __webpack_public_path__ + "static/media/message_read.87ea0abf3288857a285170db2004f76d.svg";
export { ForwardRef as ReactComponent };